import { ChartConfig } from '@/components/ui/chart'
import { Icon } from '@iconify/react'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import * as React from 'react'
import { schema } from '@/pages/powerdoc-project-view'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

const chartData = [
  { month: 'January', desktop: 186, mobile: 80 },
  { month: 'February', desktop: 305, mobile: 200 },
  { month: 'March', desktop: 237, mobile: 120 },
  { month: 'April', desktop: 73, mobile: 190 },
  { month: 'May', desktop: 209, mobile: 130 },
  { month: 'June', desktop: 214, mobile: 140 },
]

const chartConfig = {
  desktop: {
    label: 'Desktop',
    color: 'var(--primary)',
  },
  mobile: {
    label: 'Mobile',
    color: 'var(--primary)',
  },
} satisfies ChartConfig

export function TableCellViewer({ item }: { item: z.infer<typeof schema> }) {
  const isMobile = true
  const [url, setUrl] = useState<string>('')
  const params = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    if (item) {
      if (item.proposalId) {
        setUrl(`/client/${params.clientUUID}/document/${params.documentUUID}/proposal`)
      } else if (item.quotationId) {
        setUrl(`/client/${params.clientUUID}/document/${params.documentUUID}/quotation`)
      } else if (item.offerId) {
        setUrl(`/client/${params.clientUUID}/document/${params.documentUUID}/offer`)
      } else {
        setUrl(`/client/${params.clientUUID}/document/${params.documentUUID}/custom/${params.customDocUUID}`)
      }
    }
  }, [item])
  return (
    <Button
      variant="link"
      className="text-foreground w-fit px-0 text-left max-w-[250px]"
      style={{
        whiteSpace: 'wrap',
        height: 'fit-content',
      }}
      onClick={() => {
        navigate(url + `?section=${item.uuid}`)
      }}
    >
      <span className="flex gap-2 items-center min-w-0">
        <Icon icon="lucide:pen" className="text-muted-foreground shrink-0" />
        <span className="truncate">{item.title}</span>
      </span>
    </Button>
  )
}
